import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ca0215e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content has-background-contents shadow" }
const _hoisted_2 = { class: "input-form authorInfo" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title contents-title" }, "著者情報", -1))
const _hoisted_4 = { class: "table" }
const _hoisted_5 = { class: "input-form contactInfo" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title contents-title" }, "ご連絡先（あなた様）", -1))
const _hoisted_7 = { class: "table" }
const _hoisted_8 = { class: "navigation" }
const _hoisted_9 = { class: "navigation-button" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "navigation-text" }, " 戻る ", -1))
const _hoisted_11 = { class: "navigation-button" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "navigation-text" }, " 情報提供を送信 ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmInput = _resolveComponent("ConfirmInput")!
  const _component_DssIcon = _resolveComponent("DssIcon")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_ToPageTop = _resolveComponent("ToPageTop")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("table", _hoisted_4, [
          _createElementVNode("tbody", null, [
            _createVNode(_component_ConfirmInput, {
              name: '著者ID',
              value: _ctx.authorInfoData.authorId,
              class: _normalizeClass('authorId')
            }, null, 8, ["value"]),
            _createVNode(_component_ConfirmInput, {
              name: '著者名',
              value: _ctx.authorInfoData.authorName,
              class: _normalizeClass('authorName')
            }, null, 8, ["value"]),
            _createVNode(_component_ConfirmInput, {
              name: '著者の情報',
              value: _ctx.authorInfoData.authorInfo,
              class: _normalizeClass('authorInfo')
            }, null, 8, ["value"]),
            _createVNode(_component_ConfirmInput, {
              name: '情報源',
              value: _ctx.authorInfoData.infoSource,
              class: _normalizeClass('infoSource')
            }, null, 8, ["value"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("table", _hoisted_7, [
          _createElementVNode("tbody", null, [
            _createVNode(_component_ConfirmInput, {
              name: '氏名',
              value: _ctx.contactInfoData.name,
              class: _normalizeClass('name')
            }, null, 8, ["value"]),
            _createVNode(_component_ConfirmInput, {
              name: 'メールアドレス',
              value: _ctx.contactInfoData.mailAddress,
              class: _normalizeClass('mailAddress')
            }, null, 8, ["value"]),
            _createVNode(_component_ConfirmInput, {
              name: '住所',
              value: _ctx.contactInfoData.address,
              class: _normalizeClass('address')
            }, null, 8, ["value"]),
            _createVNode(_component_ConfirmInput, {
              name: '電話番号',
              value: _ctx.contactInfoData.phoneNumber,
              class: _normalizeClass('phoneNumber')
            }, null, 8, ["value"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_AppButton, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.push('/dms/author/input'))),
            onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (_ctx.router.push('/dms/author/input')), ["prevent"]), ["space","enter"])),
            buttonId: 'button-back'
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DssIcon, {
                icon: "arrow-left",
                style: {"font-size":"18px"}
              }),
              _hoisted_10
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_AppButton, {
            onClick: _ctx.send,
            onKeydown: _withKeys(_withModifiers(_ctx.send, ["prevent"]), ["space","enter"]),
            styled: 'is-accent',
            buttonId: 'button-send',
            disabled: !_ctx.authorInfoData.authorId || !_ctx.contactInfoData.name || !_ctx.contactInfoData.mailAddress
          }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          }, 8, ["onClick", "onKeydown", "disabled"])
        ])
      ])
    ]),
    _createVNode(_component_ToPageTop)
  ], 64))
}